<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uoBSno/tc-custom/9781466805798.jpg?1730613476398" alt="This image is the cover for the book Edward VI"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Edward VI
      </h1>
      <p class="bookDescription body article font2">
        <p><i>The birth of </i><i>Edward</i><i> on </i><i>October 12, 15</i><i>37</i><i>, ended his father's twenty-seven-year wait for an heir. Nine years later, </i><i>Edward</i><i> was on the throne, a boy-king in a court where manipulation, treachery, and plotting were rife.</i><br/><br/><br/><br/>Henry VIII's death in January 1547 marked the end of a political giant whose reign had dominated his kingdom with an iron grip for thirty-eight years. Few could remember an England without him---certainly little had remained untouched: the monasteries and friaries had been ripped down, the Pope's authority discarded, and new authoritarian laws had been introduced that placed his subjects under constant fear of death.<br/><br/>Edward came to the throne promising a new start; the harsh legislation of his father's was repealed and the country's social and economic problems approached with greater sensitivity. Yet the early hope and promise he offered soon turned sour. Despite the terms of Henry's will, real power had gone to just one man---the Protector, Edward's uncle, the Duke of Somerset, and there were violent struggles for power, headed by the duke's own brother, Thomas Seymour.<br/><br/>Chris Skidmore reveals how the countrywide rebellions of 1549 were orchestrated by the plotters at court and were all connected to the burning issue of religion: Henry VIII had left England in a religious limbo. Court intrigue, deceit, and treason very nearly plunged the country into civil war. The stability that the Tudors had sought to achieve came close to being torn apart in the six years of Edward's reign.<br/><br/>Even today, the two dominant figures of the Tudor period are held to be Henry VIII and Elizabeth I. Yet Edward's reign is equally important. His reign was one of dramatic change and tumult, yet many of the changes that were instigated during this period---certainly in terms of religious reformation---not only exceeded Henry's ambitions but have endured for over four centuries since Edward's death in 1553.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris Skidmore
      </h2>
      
      <p class="authorDescription body article"><P>Chris Skidmore was born in Bristol, England, in 1981. He is a prize-winning honors graduate of Oxford University and is adviser to the British Shadow Secretary for Education.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macmillan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a233abf